export type {
  MediaGalleryCarouselOverlayIcon,
  MediaGalleryCarouselProps,
} from "./media-gallery-carousel";
export { MediaGalleryCarousel } from "./media-gallery-carousel";
